import { render, staticRenderFns } from "./UltimateShareFooterWrapper.vue?vue&type=template&id=58c0441c&"
import script from "./UltimateShareFooterWrapper.vue?vue&type=script&lang=ts&"
export * from "./UltimateShareFooterWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./UltimateShareFooterWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports